"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultConfig = void 0;
var language_tag_1 = require("../language-tag");
var currency_1 = require("./currency");
var date_1 = require("./date");
var monetary_value_1 = require("./monetary-value");
var number_1 = require("./number");
var person_name_1 = require("./person-name");
/**
 * The default config options for I18N.
 */
exports.defaultConfig = {
    languageTag: language_tag_1.LanguageTag.English,
    date: date_1.defaultDateConfig,
    number: number_1.defaultNumberConfig,
    currency: currency_1.defaultCurrencyConfig,
    monetaryValue: monetary_value_1.defaultMonetaryValueConfig,
    personName: person_name_1.defaultPersonNameConfig
};
//# sourceMappingURL=config.js.map